export const Dj_WORDS = ['ĐAKON', 'ĐUBRE']
